import { AxiosResponse } from "axios";
import API from "../api";
import { AccessSettings } from "../models/access.settings";
import { PdfReport } from "../models/pdf.report";
import BaseService from "./_base.service";
import { StorageBox } from "../models/storage.box";
import {
  CostingReportCSV,
  OrdersManagementCSV,
  OrdersManagementResponse,
  OrdersManagementWidgets,
} from "Models/report.orders.management";
import { GenerateJob } from "Models/generate.job";

const endpoint = "orders/management/reports";

export interface GenerateOrdersManagement {
  storageBoxes?: StorageBox[];
  startDate?: string;
  endDate?: string;
  status?: Array<"In Use" | "Empty">;
  limit?: number;
}

const OrdersManagementReportService = {
  ...BaseService<AccessSettings>({ endpoint }),

  async getOrdersManagementReports(
    options?: any
  ): Promise<AxiosResponse<OrdersManagementResponse>> {
    return await API.get(`/${endpoint}`, { params: options });
  },

  async getOrdersManagementWidgets(options?: any): Promise<AxiosResponse<OrdersManagementWidgets>> {
    return await API.get(`/${endpoint}/widgets`, { params: options });
  },

  async getOrdersManagementExportCSVData(
    options?: any
  ): Promise<AxiosResponse<OrdersManagementCSV[]>> {
    return await API.get(`/${endpoint}/export`, { params: options });
  },

  async getOrdersManagementOrderReportExportCSVData(
    options?: any
  ): Promise<AxiosResponse<OrdersManagementCSV[]>> {
    return await API.get(`/${endpoint}/order/export`, { params: options });
  },

  async getOrdersCostingExportCSVData(options?: any): Promise<AxiosResponse<CostingReportCSV[]>> {
    return await API.get(`/${endpoint}/costing/export`, { params: options });
  },

  async generateOrdersCostingReport(
    generate: GenerateJob
  ): Promise<AxiosResponse<PdfReport>> {
    return await API.post(`/${endpoint}/costing/generate`, generate);
  },
};

export default OrdersManagementReportService;
